import Grid from '@/global/components/ui/Grid'
import { CategoriaEnum, Categorias } from '@acme/auth'
import { FormField, FormFieldSelect } from 'global/components/Form'
import { useFormContext } from 'react-hook-form'

const CATEGORIAS_COM_CLIENTE = [
    CategoriaEnum.Cliente,
    CategoriaEnum.Avaliacao,
    CategoriaEnum.Supervisor,
    CategoriaEnum.Funcionario,
]

const OPCOES = Object.entries(Categorias)
    .filter(([id]) => Number(id) !== CategoriaEnum.Publico)
    .map(([id, label]) => ({ value: Number(id), label }))

export function EditarUsuarioFormFields() {
    const { watch } = useFormContext()
    const categoriaId = watch('categoriaId')

    return (
        <Grid container>
            <Grid item xs={12}>
                <FormFieldSelect
                    disabled
                    name="categoriaId"
                    label="Categoria de acesso"
                    options={OPCOES}
                />
            </Grid>
            <Grid item xs={12}>
                <FormField name="email" label="Email" required type="email" />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="nome"
                    label="Nome"
                    max={50}
                    autoComplete="off"
                    helperText="Deixe em branco para exibir o nome derivado do cadastro."
                />
            </Grid>
            {CATEGORIAS_COM_CLIENTE.includes(categoriaId) && (
                <Grid item xs={12}>
                    <FormField
                        name="clienteId"
                        label="ID do Cliente"
                        type="number"
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6}>
                <FormField
                    name="password"
                    label="Nova senha (opcional)"
                    type="password"
                    autoComplete="new-password"
                    helperText="Deixe em branco para manter"
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme a nova senha"
                    type="password"
                    autoComplete="new-password"
                />
            </Grid>
        </Grid>
    )
}
